<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Translations</h1>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="d-flex gap-3 align-items-center mb-3">
      <input [(ngModel)]="filters.values['domain']" (ngModelChange)="onInputChange()" class="form-control w-25" placeholder="Domain filter" type="text"/>

      <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
        <i class="bi bi-floppy"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()" title="Clear filters">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead>
          <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
            <th tableSorterHeader="id">ID</th>
            <th tableSorterHeader="domain">Domain</th>
            <th tableSorterHeader="description">Description</th>
            <th>Locales</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (translationDomain of translationDomains; track translationDomain) {
            <tr>
              <td>{{ translationDomain.id }}</td>
              <td>{{ translationDomain.domain }}</td>
              <td>{{ translationDomain.description }}</td>
              <td>
                @if (translationDomain.baseLocale) {
                  <a
                    [href]="$safeNavigationMigration(translationDomain.getBaseToLocale()?.previewUrl)" target="_blank">
                    <img [ngSrc]="langService.getFlag(translationDomain.baseLocale)"
                      [alt]="translationDomain.baseLocale" width="24" height="24" class="me-1">
                  </a>
                }
                @if (translationDomain.getToLocales().length) {
                  <span class="me-1"><i class="bi bi-arrow-right"></i></span>
                }
                @for (domainLocale of translationDomain.getToLocales(); track domainLocale) {
                  <a
                    [href]="domainLocale.previewUrl" target="_blank">
                    <img [ngSrc]="langService.getFlag(domainLocale.locale ?? '')" [alt]="domainLocale.locale" width="24"
                      height="24" class="me-1">
                  </a>
                }
              </td>
              <td class="text-center">
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[translationDomain.id]"><i
                class="bi bi-pencil me-1"></i>Manage
              </a>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
  </div>
</div>
</div>
